'use strict';
module.exports = function ajaxBlobFetch(url, navigatorShim, options) {
	const notify = function (progress) {
		if (options && options.notify) {
			options.notify(progress);
		}
	};
	// jQuery ajax does not support binary transport yet
	return new Promise(function (resolve, reject) {
		const http = navigatorShim.buildXMLHttpRequest(),
			fail = function () {
				reject({xhr: http, statusText: http.statusText, status: http.statusText});
			};

		http.addEventListener('load', function () {
			if (http.status === 200) {
				resolve({response: http.response, contentType: http.getResponseHeader('content-type')});
			} else {
				fail();
			}
		});
		http.addEventListener('error', fail);
		http.addEventListener('abort', fail);
		http.addEventListener('progress', function (oEvent) {
			if (oEvent.lengthComputable) {
				notify(Math.round((oEvent.loaded * 100) / oEvent.total, 2) + '%');
			} else {
				notify();
			}
		});
		http.open('GET', url, true);
		http.responseType = 'blob';
		http.send();
	});
};
